/**
 * Per-status badge theme, per the design's colour ruling: À venir = gris, En cours = jaune,
 * Atteint = vert, Bloqué = orange (the Bloqué colour is still an open UI point — it has no
 * example in the mock-up). Shared by the Résumé timeline, the milestones widget table and the
 * milestone form's status pills, so the three can never disagree.
 */
export const milestoneStatusTheme = {
    Upcoming: "neutral",
    InProgress: "yellow",
    Achieved: "green",
    Blocked: "orange",
};
